



























import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {uploadFile} from '@/utils/commonUtils';
import {toI18n} from '@/utils/commonUtils';
import { MAX_ADDABLE_UPLOAD_IMAGE_COUNT, MAX_ALL_UPLOAD_IMAGE_COUNT } from '@/const/product';

type AddableUploadImagesType = {
  displayOrder: number;
  imageUrl: string;
  isImageDel: boolean;
  originImageUrl: string | null;
  symbolic: boolean;
}[];

@Component
export default class ProductListImageArea extends Vue {
  public toI18n(needToI18nStr: string, param?: Record<string, string|number>): string {
    return toI18n(this.$t(`PRODUCT_PRODUCTLIST_${needToI18nStr}`, param));
  }
  @Prop({
    required: false,
    default: false,
    type: Boolean
  })
  public readonly disable?: boolean;

  @Prop({
    required: true,
    default: function () {
      return [];
    },
    type: Array
  })
  private readonly imagesList!: [];
  public readonly MAX_ADDABLE_UPLOAD_IMAGE_COUNT = MAX_ADDABLE_UPLOAD_IMAGE_COUNT;
  public readonly MAX_ALL_UPLOAD_IMAGE_COUNT = MAX_ALL_UPLOAD_IMAGE_COUNT;

  @Watch('imagesList')
  onImageListChange() {
    this.allImagesList = [...this.handleArray(this.imagesList)];
  }

  public allImagesList: AddableUploadImagesType = [];

  get filteredAddableUploadImages() {
    return this.allImagesList.filter(({symbolic}) => !symbolic);
  }

  private handleArray(imageList: []) {
    return imageList.map((imgInfo: any) => {
      return {...imgInfo, isImageDel: false};
    });
  }

  public imageData() {
    return this.allImagesList
      .filter((imageInfo: any) => !imageInfo.isImageDel)
      .map((imageInfo: any) => {
        return {imageUrl: imageInfo.imageUrl, mainYn: imageInfo.symbolic ? 'Y' : 'N'};
      });
  }

  public openUploadDialog(ref: string) {
    const fileInput = this.$refs[ref] as any;
    if (Array.isArray(fileInput)) {
      fileInput[0].value = '';
      fileInput[0].click();
    } else {
      fileInput.value = '';
      fileInput.click();
    }
  }

  public uploadImage(e: any) {
    const inputFiles: File[] = e.target.files || e.dataTransfer.files;
    const id = e.target.id;
    let files = Array.from(inputFiles);
    const fileType = Object.values(files).map((file: any): any => ['image/png', 'image/jpeg', 'image/gif', 'image/bmp'].includes(file.type));

    if (fileType.includes(false)) {
      alert(this.toI18n('PLIMAGEAREA_ALERT1')); //이미지파일(Jpg,jpge,gif,png,bmp)만 등록해주세요.
      return;
    }

    const fileSize = Object.values(files).map((file: any): any => Math.ceil(file.size / 1024) > 1024 * MAX_ADDABLE_UPLOAD_IMAGE_COUNT);
    if (fileSize.includes(true)) {
      alert(window.$t('COMMON_FILE_SIZE_ERR_IMG', [`${MAX_ADDABLE_UPLOAD_IMAGE_COUNT}M`]));
      return;
    }

    if (id === 'multipleUpload') {
      const {length: additionalImageCount} = this.filteredAddableUploadImages;
      const isExceedUploadImageCount = additionalImageCount + files.length > MAX_ALL_UPLOAD_IMAGE_COUNT;

      if (isExceedUploadImageCount) {
        alert(this.$t('PRODUCT_ADD_INVALID_UPLOAD_ADDABLE_IMAGE_COUNT', {count: MAX_ADDABLE_UPLOAD_IMAGE_COUNT}));
        
        const greaterIndex = MAX_ADDABLE_UPLOAD_IMAGE_COUNT - additionalImageCount;

        files.splice(greaterIndex);
      }
    }

    uploadFile(files, this.$route.params.mallNo).then((responses: any): void => {
      const data = responses.map((res: any): {} => {
        return {imageUrl: res.data.url, isImageDel: false};
      });

      if (id === 'multipleUpload') {
        this.allImagesList = [...this.allImagesList, ...data];
      } else {
        const imageUrl = data[0].imageUrl;
        const isImageDel = false;
        const displayOrder = parseInt(id.substring(id.length - 1), 10);

        Object.assign(this.allImagesList[displayOrder], {imageUrl, isImageDel, displayOrder});
        
        if (displayOrder === 0) {
          this.$emit('mainImgUploaded');
        }
      }
    });
  }
  public remove(idx: number) {
    if (idx === 0) {
      this.allImagesList[idx].isImageDel = true;
    } else {
      this.allImagesList.splice(idx, 1);
    }
  }
}
